// HTTP status from an axios-style error (`response.status`) or a plain `status` field.
const statusOf = (error: unknown): number | undefined =>
  (error as { response?: { status?: number }, status?: number })?.response?.status
  ?? (error as { status?: number })?.status;

export default statusOf;
